import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { AlertTriangle, FileCheck2, FileText } from "lucide-react";

/**
 * V1.21 · Modal ligero con la lista de documentos pendientes del alumno.
 * Se abre al hacer click en el chip "Faltan N" del listado/ficha.
 */
export default function MissingDocsDialog({ open, onClose, student, missing = [] }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="missing-docs-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {missing.length === 0 ? (
              <FileCheck2 className="h-5 w-5 text-green-600" />
            ) : (
              <AlertTriangle className="h-5 w-5 text-amber-500" />
            )}
            Documentación de {student?.name || "alumno"}
          </DialogTitle>
          <DialogDescription>
            {missing.length === 0
              ? "Este alumno tiene toda la documentación al día."
              : `Faltan ${missing.length} documento${missing.length === 1 ? "" : "s"} por entregar.`}
          </DialogDescription>
        </DialogHeader>
        {missing.length > 0 && (
          <ul className="space-y-1.5 max-h-[60vh] overflow-y-auto pr-1">
            {missing.map((name) => (
              <li
                key={name}
                data-testid={`missing-doc-item-${name}`}
                className="flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50/60 px-3 py-2 text-sm text-amber-900"
              >
                <FileText className="h-4 w-4 text-amber-600 shrink-0" />
                <span className="font-medium">{name}</span>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
}
